module.exports = __webpack_public_path__ + "static/img/HVU_Logo.a391428.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/HVU_Logo.svg
// module id = 1y3O
// module chunks = 1